import { PortableTextBlock } from '@portabletext/react'

import { DefaultLayout } from './default'
import { V1Layout } from './v1'
import { V2Layout } from './v2'
import { CompareCredit } from '../../../../types'

type DetailsType = Array<{
  description: PortableTextBlock[]
  _key: string
  headline: string
  icon: any
}>

const layouts = {
  default: ({
    content,
    referencedCards,
  }: {
    content: PortableTextBlock[]
    referencedCards: null | Record<string, CompareCredit.Entity>
  }) => <DefaultLayout content={content} referencedCards={referencedCards} />,
  v1: ({
    details,
    referencedCards,
  }: {
    details: DetailsType
    referencedCards: null | Record<string, CompareCredit.Entity>
  }) => <V1Layout details={details} referencedCards={referencedCards} />,
  v2: ({
    details,
    referencedCards,
  }: {
    details: DetailsType
    referencedCards: null | Record<string, CompareCredit.Entity>
  }) => <V2Layout details={details} referencedCards={referencedCards} />,
}

export const TipBottomLine = (data: {
  referencedCards: null | Record<string, CompareCredit.Entity>
}) => {
  const render: React.FC<{
    value: {
      type: 'default' | 'v1' | 'v2'
      content?: PortableTextBlock[]
      details?: DetailsType
    }
  }> = ({ value: { type, content, details } }) => {
    const { referencedCards } = data

    const Layout = layouts[type] || layouts.default
    return Layout({
      content: content || [],
      referencedCards,
      details: details || [],
    })
  }
  return render
}
